<template>
  <form class="v-form">
    <slot></slot>
  </form>
</template>
<script>
let defaults = {
  placement: 'top',
  errorsWrapper: false,
  triggerAfterFailure: 'input change',
  excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled]'
}

let createFormInstance = function ($formEl, formOptions = {}) {
  // apply default options
  Object.assign(formOptions, defaults)

  let formInstance = $formEl.parsley(formOptions)
    .on('form:reset', function () {
      this.$element.find('span[id^=parsley-id], span[for^=parsley-id]').tooltip('destroy')
    })
    .on('form:destroy', function () {
      this.$element.find('span[id^=parsley-id], span[for^=parsley-id]').tooltip('destroy')
    })
    .on('field:reset', function (fieldInstance) {
      fieldInstance.$element.tooltip('destroy')
    })
    .on('field:destroy', function (fieldInstance) {
      fieldInstance.$element.tooltip('destroy')
    })
    .on('field:error', function (fieldInstance) {
      fieldInstance.$element
        .tooltip('destroy')
        .tooltip({
          html: true,
          animation: false,
          placement: formOptions.placement,
          title: fieldInstance.getErrorsMessages()
        })
    })
    .on('field:success', function (fieldInstance) {
      fieldInstance.$element.tooltip('destroy')
    })

  return formInstance
}

export default {
  data: function () {
    return {
      $formStatus: null,
      $formInstance: null
    }
  },
  props: {
    formOptions: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  mounted: function () {
    let $formEl = $(this.$el)

    this.$formStatus = 'init'
    this.$formInstance = createFormInstance($formEl, this.formOptions)
  },
  methods: {
    reset: function () {
      this.$formStatus = 'reset'
      this.$formInstance.reset()
    },
    destroy: function () {
      let $formEl = $(this.$el)

      this.$formStatus = 'init'
      this.$formInstance.destroy()
      this.$formInstance = createFormInstance($formEl, this.formOptions)
    },
    validate: function () {
      this.$formStatus = 'validate'
      let valid = this.$formInstance.validate()
      return valid
    },
    refresh: function () {
      let $formEl = $(this.$el)

      this.$formInstance.destroy()
      this.$formInstance = createFormInstance($formEl, this.formOptions)

      if (this.$formStatus === 'validate') {
        this.validate()
      }
    },
    addFieldConstraint: function (fieldId, name, requirements, message, reset = true) {
      let fieldInstance = this.$formInstance.fields.find(field => field.$element.attr('id') === fieldId)
      let $field = fieldInstance ? fieldInstance.$element : $('#' + fieldId)

      if (!$field) {
        throw new Error('Can not find element[id=' + fieldId + '] in form')
      }

      $field.attr('data-parsley-' + name, requirements)
      $field.attr('data-parsley-' + name + '-message', message)

      if (reset && fieldInstance) {
        fieldInstance.reset()
      }
    },
    removeFieldConstraint: function (fieldId, name, reset = true) {
      let fieldInstance = this.$formInstance.fields.find(field => field.$element.attr('id') === fieldId)
      let $field = fieldInstance ? fieldInstance.$element : $('#' + fieldId)

      if (!$field) {
        throw new Error('Can not find element[id=' + fieldId + '] in form')
      }

      $field.removeAttr('data-parsley-' + name)
      $field.removeAttr('data-parsley-' + name + '-message')

      if (reset && fieldInstance) {
        fieldInstance.reset()
      }
    },
    addFieldError: function (fieldId, name, message, reset = true) {
      let fieldInstance = this.$formInstance.fields.find(field => field.$element.attr('id') === fieldId)

      if (fieldInstance) {
        if (reset) {
          fieldInstance.reset()
        }

        let validatorName = (fieldId + name).replace(/[^a-z0-9]/gmi, '').replace(/\s+/g, '').toLowerCase()
        let validatorPresent = window.Parsley._validatorRegistry.validators[validatorName]

        if (validatorPresent) {
          window.Parsley.removeValidator(validatorName)
        }

        window.Parsley.addValidator(validatorName, function (value, requirement) {
          return requirement === ''
        })

        this.addFieldConstraint(fieldId, validatorName, name, message, reset)

        fieldInstance.$element.one('input change', function () {
          window.Parsley.removeValidator(validatorName)
          this.removeFieldConstraint(fieldId, validatorName, reset)
        }.bind(this))
      } else {
        this.$addErrorToast(message)
      }
    },
    addFormErrors: function (response, mappings = {}) {
      let vm = this

      if (response.errors) {
        let fieldIds = []

        $.each(response.errors, function (index, error) {
          let fieldId = mappings[error.field] || error.field

          if ($.inArray(fieldId, fieldIds)) {
            vm.addFieldError(fieldId, error.code, error.defaultMessage, false)
          } else {
            fieldIds.push(fieldId)
            vm.addFieldError(fieldId, error.code, error.defaultMessage, true)
          }
        })

        this.$nextTick(function () {
          this.$formInstance.validate()
        })
      }
    }
  }
}
</script>
<style lang="scss">
.v-form {
  .parsley-error {
    border: 1px solid #f00 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/Form.vue